/* src/app/help-page/help-page.component.scss */
.help {
  position: absolute;
  width: 100%;
  height: 100%;
}
@media (min-width: 768px) {
  .help {
    max-width: 414px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
  }
}
.help h2 {
  color: #fff;
  font-weight: bold;
  font-size: 20px;
  position: relative;
  text-align: center;
  top: 50px;
}
.data-symbol {
  position: absolute;
  top: calc(var(--ion-safe-area-top) + 25px);
  left: 25px;
  width: 50px;
  height: 50px;
}
.data-symbol:hover {
  cursor: pointer;
}
.text {
  max-height: 150px;
  overflow: scroll;
  white-space: pre-line;
  padding: 10px;
  background: rgba(255, 255, 255, 0.9);
  max-width: 50%;
  position: absolute;
  right: 25px;
  min-width: 250px;
  bottom: 200px;
  height: fit-content;
  border-radius: 18px;
}
@media (min-height: 700px) {
  .text {
    max-height: 70%;
  }
}
.human-illustration {
  position: absolute;
  bottom: 120px;
}
.download {
  position: absolute;
  z-index: 1000;
  top: 100px;
  right: 25px;
}
.download-2 {
  position: absolute;
  z-index: 1000;
  top: 170px;
  right: 25px;
}
button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px;
  color: #fff;
  border-radius: 100px;
  font-size: 14px;
  margin: 5px 0;
  background: rgba(181, 181, 181, 0.7);
}
button img {
  width: 24px;
  height: 24px;
  margin-left: 5px;
}
.export-icon {
  color: #fff;
  font-size: 40px;
}
.user-info {
  position: absolute;
  top: 40px;
  right: 10px;
  z-index: 100;
  color: #fff;
}
/*# sourceMappingURL=help-page.component.css.map */
